import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStorage } from '@vueuse/core';

import FirstPageDark from '@/assets/images/sltpTutorial/firstPage-Dark.jpg';
import FirstPageLight from '@/assets/images/sltpTutorial/firstPage-Light.jpg';
import SecondPageDark from '@/assets/images/sltpTutorial/secondPage-Dark.jpg';
import SecondPageLight from '@/assets/images/sltpTutorial/secondPage-Light.jpg';
import ThirdPageDark from '@/assets/images/sltpTutorial/thirdPage-Dark.jpg';
import ThirdPageLight from '@/assets/images/sltpTutorial/thirdPage-Light.jpg';
import FourthPageDark from '@/assets/images/sltpTutorial/fourthPage-Dark.jpg';
import FourthPageLight from '@/assets/images/sltpTutorial/fourthPage-Light.jpg';
import FifthPageDark from '@/assets/images/sltpTutorial/fifthPage-Dark.jpg';
import FifthPageLight from '@/assets/images/sltpTutorial/fifthPage-Light.jpg';

export type TutorialStep = {
  image: string;
  title: string;
  description: string;
};

export function useSltpTutorialSteps() {
  const { t } = useI18n();
  const themeMode = useStorage<'light' | 'dark' | 'auto'>(
    'vueuse-color-scheme',
    'light'
  );

  const isDark = computed(() => {
    if (themeMode.value === 'dark') return true;
    if (themeMode.value === 'light') return false;

    if (typeof window === 'undefined') return false;
    return (
      window.matchMedia?.('(prefers-color-scheme: dark)')?.matches ?? false
    );
  });
  const steps = computed<TutorialStep[]>(() => {
    const theme = isDark.value ? 'dark' : 'light';
    return [
      {
        image: theme === 'dark' ? FirstPageDark : FirstPageLight,
        title: t('modules.order.sltp_tutorial.first_page_title'),
        description: t('modules.order.sltp_tutorial.first_page_description'),
      },
      {
        image: theme === 'dark' ? SecondPageDark : SecondPageLight,
        title: t('modules.order.sltp_tutorial.second_page_title'),
        description: t('modules.order.sltp_tutorial.second_page_description'),
      },
      {
        image: theme === 'dark' ? ThirdPageDark : ThirdPageLight,
        title: t('modules.order.sltp_tutorial.third_page_title'),
        description: t('modules.order.sltp_tutorial.third_page_description'),
      },
      {
        image: theme === 'dark' ? FourthPageDark : FourthPageLight,
        title: t('modules.order.sltp_tutorial.fourth_page_title'),
        description: t('modules.order.sltp_tutorial.fourth_page_description'),
      },
      {
        image: theme === 'dark' ? FifthPageDark : FifthPageLight,
        title: t('modules.order.sltp_tutorial.fifth_page_title'),
        description: t('modules.order.sltp_tutorial.fifth_page_description'),
      },
    ];
  });

  return { steps };
}
